<template>
  <div class="app-body" ref="body">
    <div class="app-header">
      <div class="logo">
        <img :src="sitelogo" style="display:inline-block; height:3rem;">
      </div>
      <div class="title" @click="handleClickFocus">{{ focus.title }}</div>
      <div class="user" @click="handleClickUser">
        <van-icon name="user-circle-o" />
      </div>
    </div>
    <van-pull-refresh v-model="isLoading" @refresh="onRefresh" style="margin-top:4rem;">
      <van-swipe :autoplay="3000" :style="imageStyle" class="home-swipe0" @change="onChange">
        <van-swipe-item v-for="item in focusList" :key="item.id" @click="handleClickFocus(item)">
          <van-image
            fit="cover"
            lazy-load
            :src="rootPath + item.pic"
            width="100%"
          />
          <!-- <p v-if="item.title" class="tit">{{ item.title }}</p> -->
        </van-swipe-item>
      </van-swipe>
      <van-cell-group title="" class="home-grid">
        <van-grid :border="false" :column-num="3" ref="grid">
          <van-grid-item
            v-for="item in list"
            :key="item.id"
            @click="toCate(item)"
            clickable
          >
            <div v-if="!item.pic" slot="icon" class="icon" :style="bgStyle(item)"><i class="fa" :class="['fa-'+ item.navname]"></i></div>
            <div v-if="item.pic" slot="icon" class="pic" :style="imageStyle2">
              <van-image
                fit="contain"
                lazy-load
                :src="rootPath + item.pic"
                width="100%"
              />
            </div>
            <div slot="text" class="txt">{{ item.name }}</div>
          </van-grid-item>
        </van-grid>
      </van-cell-group>
    </van-pull-refresh>
  </div>
</template>

<script>
//:to="{name:'site-list', params:{id: item.id}}"
import { mapGetters } from 'vuex';
import tools from '@/utils/tools';
import { getLightColor } from '@/utils/utils';
import AppFooter from '../app-footer.vue';
export default {
  components: {
    AppFooter
  },
  mixins: [tools],
  data() {
    return {
      isLoading: false,
      finished: false,
      count: 0,
      page: 1,
      list: [],
      error: false,
      w: 0,
      focusLoading: false,
      focusList: [],
      focus: {}
    }
  },
  computed: {
    ...mapGetters([]),
    imageStyle() {
      let style = {};
      if (this.w) {
        style = {height: (this.w * 0.61) + 'px'};
      }
      return style;
    },
    imageStyle2() {
      let style = {}
      if (this.w) {
        style = {height: (this.w * 0.68 * 0.3) + 'px'};
      }
      return style;
    },
  },
  watch: {
    '$route'(to, from) {
      // console.log(to, from)
    }
  },
  created () {
    // resize
    let resizeId;
    window.addEventListener('resize', () => {
      clearTimeout(resizeId);
      resizeId = setTimeout(this.getImgW, 300);
    });
  },
  mounted () {
  },
  activated() {
    if (!this.list || !this.list.length) {
      this.loadData();
    }
    if (!this.focusList || !this.focusList.length) {
      this.loadFocus();
    }
    if (!this.w) {
      this.getImgW();
    }
  },
  methods: {
    loadData(callback) {
      if (this.isLoading) {
        return;
      }
      this.isLoading = true;
      this.doPost({
        url: 'vue/home',
        data: {},
        okcb: (json) => {
          if (callback && callback instanceof Function) {
            callback(json);
          } else {
            this.list = json.catelist;
          }
        },
        cb: () => {
          this.$nextTick(() => this.isLoading = false);
        },
        errcb: () => {
          this.error = true;
        }
      });
    },
    loadFocus() {
      this.focusLoading = true;
      this.doPost({
        url: 'vue/home/loadFocus',
        okcb: (json) => {
          this.focusList = json;
          this.focus = json[0] || {};
        },
        cb: () => {
          this.focusLoading = false;
        }
      });
    },
    initData(list) {
    },
    getImgW() {
      this.$nextTick(() => {
        this.w = this.$refs.body && this.$refs.body.offsetWidth;
      });
    },
    onRefresh() {
      this.isLoading = false;
      this.loadData((json) => {
        this.list = json.catelist;

        this.$toast('刷新成功');
      });
      this.loadFocus();
    },
    handleClickFocus(item) {
      item = item || this.focus;
      if (item.url) {
        top.location.href = item.url;
      }
    },
    handleClickUser() {
      this.$router.push('/user');
    },
    onChange(index) {
      this.focus = this.focusList[index];
    },
    bgStyle(item) {
      if (!item.bgcolor) {
        return {};
      }
      return {'background-image': ('linear-gradient(to bottom, '+ item.bgcolor +','+ getLightColor(item.bgcolor, 0.5) +')')};
    },
    toCate(item) {
      if (item.outurl) {
        top.location.href = item.outurl;
      } else {
        if (item.issignup) {
          this.$router.push('/list-s/'+ item.id);
        } else {
          this.$router.push('/list/'+ item.id);
        }
      }
    }
  }
}
</script>

<style lang="less" scoped>
@font-face {
  font-family:'fzhz';
  src: url('/static/fonts/fzhz.woff2') format('woff2'),
       url('/static/fonts/fzhz.woff') format('woff');
  font-weight:normal;
  font-style:normal;
}
.app-body{}
.app-header {
  position:fixed;
  top:0;
  z-index:99;
  height:4rem;
  width:100%;
  padding:.5rem .6rem .5rem 0;
  box-sizing:border-box;
  .flex-center();
  justify-content:space-between;
  .fixedapp();
  background-color:#fff;
  .logo {
    flex-shrink:0;
    padding-top:.5rem;
  }
  .title {
    position:relative;
    flex-grow:1;
    padding:.5rem .8rem 0;
    font-size:18px;
    .text-more();
    font-family:'fzhz';
    color:tomato;
    letter-spacing:2.5px;
    &::before {
      content:' ';
      position:absolute;
      left:0;
      top:50%;
      transform:translateY(-50%);
      margin-top:.2rem;
      width:1px;
      height:1.6rem;
      background-color:#ccc;
    }
  }
  .user {
    .flex-center();
    flex-shrink:0;
    .van-icon {
      font-size:2.6rem;
      color:#888;
    }
  }
}
.home {
  margin-top:1rem;
  min-height:calc(100vh - 46px - 50px);
  &-swipe0 {
    .van-image {
      height:100%;
      .flex-center();
    }
    .van-swipe-item {
      position:relative;
      text-align:center;
    }
    .tit {
      position:absolute;
      bottom:0;
      left:0;
      right:0;
      padding:.25rem;
      color:#333;
      .text-more();
      .bg-white(.95);
      .fontsize(1.1rem);
    }
    /deep/ .van-swipe__indicators {
      // bottom:2.6rem;
    }
    .shadow_black(0 0 1px 0, .15);
  }
  &-item {
    position:relative;
    padding-top:.5rem;
    padding-bottom:.5rem;
    background-color:#fff;
    border-top:1px #f0f0f0 solid;
    // .shadow_blur_black(4px, .06);
    .van-cell:not(:last-child)::after{
      left:0;
    }
    .van-hairline--top-bottom::after{
      border-width:0;
    }
    &:first-child {
      margin-top:0;
    }
  }
  &-detail {
    &.van-cell {
      padding-left:.6rem;
    }
  }
  &-tags {
    position:absolute;
    top:1.25rem;
    left:.6rem;
    width:4rem;
    height:2rem;
    text-align:center;
    line-height:2rem;
    color:#fff;
    background-color:@orangecolor;
    border-radius:0 .35rem .35rem 0;
    .shadow_blur_black(10px, .76);
  }
  &-swipe {
    text-align:center;
    .van-image{
      height:100%;
      border-radius:.5rem;
      overflow:hidden;
    }
    img {
      display: block;
    }
  }
  &-grid {
    margin-top:1rem;
    &.van-hairline--top-bottom::after, &.van-hairline-unset--top-bottom::after {
      border-width: 0px 0;
    }
    .van-grid-item {
      width:33.3333%;
    }
    .van-grid-item__content {
      i {
        .fontsize(1.2rem);
      }
      .icon {
        .flex-center();
        margin-bottom:.2rem;
        padding:.5rem;
        width:3.2rem;
        height:3.2rem;
        border-radius:50%;
        color:#fff;
        .bg_gd(#555, #999);
      }
      .pic {
        box-sizing:border-box;
        padding:0 .15rem;
        width:100%;
        .van-image {
          height:100%;
        }
        img {

        }
      }
      .txt {
        .fontsize(1.05rem);
        font-weight:bold;
        color:#777;
        white-space:nowrap;
        text-align:center;
      }
    }
    // .van-grid-item:nth-child(2) .icon {
    //   .bg_gd(green, #00dd00);
    // }
    // .van-grid-item:nth-child(3) .icon {
    //   .bg_gd(blue, #1989fa);
    // }
    // .van-grid-item:nth-child(4) .icon {
    //   .bg_gd(#9900cc, #9999ff);
    // }
    // .van-grid-item:nth-child(5) .icon {
    //   .bg_gd(#b55555, #CD8162);
    // }
    // .van-grid-item:nth-child(6) .icon {
    //   .bg_gd(#CD2626, #CD5B45);
    // }
  }
}
@media screen {
  @media (min-width:@appwidth) {
    .home {
      &-grid {
        .van-grid-item__content {
          .pic {
            padding:0 2rem;
            .van-image {
              // max-height:150px;
            }
          }
        }
      }
    }
  }
}
</style>